namespace GeniuzPOS.InventoryReport {
    export class IcReport02_VColumns {
        static columnsKey = 'InventoryReport.IcReport02_V';
    }
}
